import object from '@mailobj-browser/front/js/utils/object.js'
import input from '@mailobj-browser/front/js/events/types/input.js'
import { onMailModified } from './mailModified.js'

const onInput = object(onMailModified, {
  type: input
})

export default element => {
  onInput.listen(element)
}
